import { styled } from "styled-components";

export const EditButton = styled.button`
  border: none;
  outline: none;
  cursor: pointer;

  display: flex;
  padding: 4px 12px;
  align-items: center;
  border-radius: 1699px;
  background: var(--Alias-Color-Text-White-Gray-LightGray-200, #f0f0f0);
  color: var(--Alias-Color-Text-Dark-Text-Tertiary, rgba(23, 30, 38, 0.56));

  /* Web/Caption/L-14-Medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
`;

export const SelectedSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const SelectedList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

export const RowContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

export const TotalContentItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;

  & > .item-label {
    color: var(--Alias-Color-Text-Dark-Text-Secondary, rgba(23, 30, 38, 0.78));
    font-feature-settings:
      "liga" off,
      "clig" off;

    /* Mo/Body/S-14-Bold */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 142.857% */
  }

  & > .item-value {
    display: flex;
    padding: 8px 0;
    align-items: center;
    gap: 2px;
    align-self: stretch;
    border-bottom: 1px solid
      var(--Alias-Color-Line-Border, rgba(23, 30, 38, 0.1));
    color: var(--Alias-Color-Text-Dark-Text-Secondary, rgba(23, 30, 38, 0.78));
    font-feature-settings:
      "liga" off,
      "clig" off;

    /* Mo/Body/L-16-Medium */
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 24px */
  }
`;
